import { render, staticRenderFns } from "./SiderBar.vue?vue&type=template&id=4de04ecd&scoped=true&"
import script from "./SiderBar.vue?vue&type=script&lang=js&"
export * from "./SiderBar.vue?vue&type=script&lang=js&"
import style0 from "./SiderBar.vue?vue&type=style&index=0&id=4de04ecd&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4de04ecd",
  null
  
)

export default component.exports